import React, { useState } from 'react';
import AddpropertySearchbar from "../../components/Form/AddpropertySearchbar";
import Dropdown from "../../components/Form/Dropdown";
import LandlordDashboard from "../../components/LandLord/LandlordDashboard";
import ManageLands from "./ManageLands";
import PaymentMonitoring from "./PaymentMonitoring";
import LegalSupport from "./LegalSupport";
import ReqMaintaince from "./ReqMaintaince";
import PrfileBriefs from "../../components/Common/ReviewCardPanel"
import UserProfile from "../../components/LandLord/UserProfile"
import CustomButton from "../../components/Form/CustomButtonWithHover";
import StarRating from "../../components/Form/StarRating";
import ProfileImage from "../../components/Common/ProfileImage";
import 'react-lazy-load-image-component/src/effects/blur.css';
import image1 from "../../assets/images/image1.png";
import ActionLoader from "../../components/Common/ActionLoader";
import LandLordTable from "../../components/Table/LandLordTable";
import TaxConsulation from "./TaxConsulation";
import StatCardGroup from '../../components/Common/StatCardGroup';
import InfoCard from '../../components/Common/InfoCard';
import NotFound from '../../components/NotFound';
import DetailPopover from '../../components/Common/DetailPopover';
import LandLordPayoutPage from './LandLoadPayout';

const LandLordTestArea = () => {
  const [isAcceptOffer, setIsAcceptOffer] = useState(false);

  const initialData = {
    fullName: "John Doe",
    email: "johndoe@example.com",
    phoneNumber: "7012345678",
    mobileMoneyProvider: "MTN",
    mobileMoneyNumber: "0701234567",
  };

  const tenantInfoCards = [
    { label: "Tenant Name", value: "Component" },
    { label: "Property Name", value: "Component" },
    { label: "Unit ID / Name", value: "Component" },
    { label: "Monthly Rent", value: "Component" },
    { label: "Deposit Received", value: "Component" },
    { label: "Paid-Through Date", value: "Component" },
    { label: "Outstanding Days", value: "Component" },
  ];

  const handleSave = (data) => {
    console.log("User data saved:", data);
  };

  const handleCancel = () => {
    console.log("Cancelled");
  };

  const dummyReviews = [
    {
      profilePicture: null,
      userName: "Alice Johnson",
      companyName: "TechWave Inc.",
      starRating: 5,
      description: "An outstanding experience! The team was highly professional and delivered ahead of schedule. An outstanding experience! The team was highly professional and delivered ahead of schedule. An outstanding experience! The team was highly professional and delivered ahead of schedule.",
    },
    {
      profilePicture: "https://randomuser.me/api/portraits/men/45.jpg",
      userName: "Brian Smith",
      companyName: "Fintech Core",
      starRating: 4,
      description: "Solid support and great communication throughout the project.",
    },
    {
      profilePicture: "https://randomuser.me/api/portraits/women/22.jpg",
      userName: "Carla Gomez",
      companyName: "EduSmart",
      starRating: 5,
      description: "They understood our needs perfectly and translated them into a beautiful product.",
    },
    {
      profilePicture: null,
      userName: "David Lee",
      companyName: "Buildify",
      starRating: 3,
      description: "Overall good, though we had to reiterate some requirements a few times.",
    },
    {
      profilePicture: "https://randomuser.me/api/portraits/men/78.jpg",
      userName: "Ethan Wright",
      companyName: "Marketly",
      starRating: 4,
      description: "Reliable, fast, and great attention to detail. Would recommend them.",
    },
    {
      profilePicture: "https://randomuser.me/api/portraits/men/78.jpg",
      userName: "Ethan Wright",
      companyName: "Marketly",
      starRating: 4,
      description: "Reliable, fast, and great attention to detail. Would recommend them.",
    },
  ];

  const handleAction = () => {
    setIsAcceptOffer(true);
    setTimeout(() => setIsAcceptOffer(false), 2000);
  };

  const [showRequestRevision, setShowRequestRevision] = useState(false);

  return (
    <div className='w-full min-h-screen p-8 bg-diagonal-sky'>
      <header className="bg-gradient-to-r from-[#873FE2] to-[#4772F1] py-6 shadow-lg opacity-90 mb-8">
        <h1 className="text-4xl font-extrabold text-center text-white md:text-5xl">
          LandLord Play Area
        </h1>
      </header>

      <div className="mb-6">
        <AddpropertySearchbar />
      </div>

      <div className="mb-6">
        <Dropdown />
      </div>

      <div className="mb-6">
        <CustomButton
          buttonText="Submit"
          bgColor="bg-[#4A90E2]"
          textColor="text-white"
          hoverEffect="scale"
          iconPosition="left"
          width="w-[200px]"
          height="h-12"
          textWeight="font-semibold"
          className="block mx-auto"
        />
      </div>

      <div className="mb-6">
        <StarRating rating={3} />
      </div>

      <div className="flex justify-center items-center w-[64px] h-[64px] rounded-full mb-6">
        <ProfileImage
          profilePicture={image1}
          firstName="Jane"
          lastName="Doe"
          fontSize="text-[20px]"
        />
      </div>

      <div className="flex justify-center mt-4 mb-6">
        <button
          onClick={handleAction}
          className="px-6 py-2 text-white transition bg-yellow-500 rounded-lg shadow hover:scale-105"
        >
          Trigger Action Loader
        </button>
      </div>

      {isAcceptOffer && (
        <div className="relative z-50">
          <ActionLoader message="Processing Payment..." loaderColor="#FBC948" />
        </div>
      )}

      <div className="bg-diagonal-sky rounded-[8px] flex lg:justify-end p-4 sm:p-[20px] md:p-[24px] lg:p-[30px] pt-0 pb-[86px] mb-6">
        <LandLordTable />
      </div>

      <div className="p-2 mb-6 bg-gray-200 sm:p-8">
        <UserProfile initialData={initialData} onSave={handleSave} onCancel={handleCancel} />
      </div>

      {/* roperty Details: Units & Tenants */}
      <div className="">
        <ManageLands />
      </div>

      {/* paymentmonitoring Notification Center */}
      <div className="">
        <PaymentMonitoring />
      </div>

      {/* Legal Support*/}
      <div className="">
        <LegalSupport />
      </div>

      {/* Request Maintenance*/}
      <div className="">
        <ReqMaintaince />
      </div>

      {/* Tax Consultation Request */}
      <div className="">
        <TaxConsulation />
      </div>

      {/*profile brief section*/}
      <div className={"mb-4"}>
        <PrfileBriefs reviews={dummyReviews}/>
      </div>

      <div className="p-3 sm:p-5 md:p-6 lg:p-[30px] bg-white rounded-[10px] shadow-[0_4px_4px_0_#0000000F]">
        <StatCardGroup items={tenantInfoCards} />
      </div>

      <div className='mt-10'>
        <InfoCard label={"single component"} value={"single component"} />
      </div>

      <div className="mt-6">
        <DetailPopover title={"Title"} text={"description"}>{"Popover"}</DetailPopover>
        <NotFound/>
      </div>
      
      <div className='mt-10'>
        <LandLordPayoutPage />
      </div>

    </div>
  );
};

export default LandLordTestArea;